import { Typography, Box } from "@mui/material";

function ShoppingBagPlaceFechado() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        padding: "25px"
      }}
    >
      <Typography variant="h5" sx={{ marginBottom: "20px"}}>
        O estabelecimento está fechado
      </Typography>
      <Typography variant="body1">
        Volte mais tarde para fazer seu pedido
      </Typography>
    </Box>
  );
}

export default ShoppingBagPlaceFechado;